/**
* 有加密的二代肛塞
*/
<template>
	<div>
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div class="min-h-screen bg-gray-50 pb-20">
			<div class="fixed top-0 w-full bg-white shadow-md z-50 px-4 py-3">
				<button @click="queryPruchasedPackages"
					:class="[ '!rounded-button w-full py-3 flex items-center justify-center gap-2',isConnected ? 'bg-green-500 text-white' : 'bg-red-500 text-white']">
					<i :class="['fas', isConnected ? 'fa-link' : 'fa-unlink']"></i>
					{{ isConnected ? $t('language000421') : $t('language000422') }}
				</button>
			</div>

			<!-- 长按开锁+长按关锁 -->
			<div class="pt-24 px-4" :class="{ 'opacity-50 pointer-events-none': !isConnected }">

				<div class="bg-white rounded-2xl shadow-sm p-5 mb-4 border border-gray-100">
					<div class="flex items-center gap-2 mb-5">
						<div class="w-1 h-5 bg-blue-500 rounded-full"></div>
						<h2 class="text-lg font-bold text-gray-800">
							<!-- 手动持续控制 -->
							{{ $t('language000463') }}
						</h2>
					</div>

					<div class="grid grid-cols-2 gap-4">
						<button @touchstart.prevent="startContinuousAction('unlock')"
							@touchend.prevent="stopContinuousAction" @mousedown="startContinuousAction('unlock')"
							@mouseup="stopContinuousAction"
							class="relative overflow-hidden group active:scale-95 transition-all duration-150 !rounded-xl py-5 bg-gradient-to-br from-green-400 to-green-600 text-white shadow-lg shadow-green-100">
							<div class="flex flex-col items-center gap-1">
								<i class="fas fa-unlock-alt text-xl mb-1"></i>
								<span class="font-bold tracking-wide">
									<!-- 长按开锁 -->
									{{ $t('language000464') }}
								</span>
								<span class="text-[10px] opacity-80 uppercase">Hold to Action</span>
							</div>
							<div v-if="pressingType === 'unlock'"
								class="absolute inset-0 bg-white opacity-20 animate-pulse"></div>
						</button>

						<button @touchstart.prevent="startContinuousAction('lock')"
							@touchend.prevent="stopContinuousAction" @mousedown="startContinuousAction('lock')"
							@mouseup="stopContinuousAction"
							class="relative overflow-hidden group active:scale-95 transition-all duration-150 !rounded-xl py-5 bg-gradient-to-br from-red-400 to-red-600 text-white shadow-lg shadow-red-100">
							<div class="flex flex-col items-center gap-1">
								<i class="fas fa-lock text-xl mb-1"></i>
								<span class="font-bold tracking-wide">
									<!-- 长按关锁 -->
									{{ $t('language000465') }}
								</span>
								<span class="text-[10px] opacity-80 uppercase">Hold to Tight</span>
							</div>
							<div v-if="pressingType === 'lock'"
								class="absolute inset-0 bg-white opacity-20 animate-pulse"></div>
						</button>
					</div>

					<div class="mt-4 flex items-center justify-center gap-2 text-gray-400">
						<span class="relative flex h-2 w-2">
							<span
								class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
							<span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
						</span>
						<p class="text-xs italic">
							<!-- 松手即刻停止，安全保护中 -->
							{{ $t('language000466') }}
						</p>
					</div>
				</div>

			</div>



			<div class="pt-20 px-4" :class="{ 'opacity-50 pointer-events-none': !isConnected }">
				<div class="bg-white rounded-xl shadow-sm p-4 mb-4">
					<h2 class="text-lg font-medium mb-4">
						<!-- 模式选择 -->
						{{ $t('language000423') }}
					</h2>

					<div class="mb-6">
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 震动模式 -->
								{{ $t('language000424') }}
							</span>

							<el-switch style="display: block" @change="toggleVibration" v-model="vibrationEnabled"
								active-color="#13ce66" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>

						</div>

						<div class="grid grid-cols-5 gap-2 mb-4">
							<button v-for="mode in 5" :key="`vib-${mode}`" @click="selectVibrationMode(mode)"
								:class="[ '!rounded-button py-2 text-sm', vibrationMode === mode ? 'bg-blue-500 text-white' : 'bg-gray-100' ]">
								<!-- 模式选择 -->
								{{ $t('language000423') }}{{ mode }}
							</button>
						</div>

						<div class="px-2">
							<input type="range" v-model="vibrationIntensity" min="1" max="5"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>2</span>
								<span>3</span>
								<span>4</span>
								<span>5</span>
							</div>
						</div>
					</div>

					<div>
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 电击模式 -->
								{{ $t('language000437') }}
							</span>

							<el-switch style="display: block" @change="setSuckingStrength" v-model="suctionEnabled"
								active-color="#F66EB8" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>

						</div>

						<div class="grid grid-cols-5 gap-2 mb-4">
							<button v-for="mode in 5" :key="`suc-${mode}`" @click="selectSuctionMode(mode)"
								:class="[ '!rounded-button py-2 text-sm', suctionMode === mode ? 'bg-blue-500 text-white' : 'bg-gray-100' ]">
								<!-- 模式选择 -->
								{{ $t('language000423') }}{{ mode }}
							</button>
						</div>

						<div class="px-2">
							<input type="range" v-model="suctionIntensity" min="1" max="5"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>2</span>
								<span>3</span>
								<span>4</span>
								<span>5</span>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				toyId: "", //传递过来的值 设备ID
				receiverID: "", //传递过来的值 生成链接的ID
				uuid: "", //传递过来的值 uuid 唯一标识
				isConnected: false, //设备是否成功连接

				pressingType: null,
				continuousTimer: null, // 持续执行的定时器
				cachedCommands: "", //获取到的蓝牙指令

				vibrationEnabled: false, //震动模式 是否开启
				vibrationMode: 1, //震动模式1~5
				vibrationIntensity: 1, //震动力度1~5

				suctionEnabled: false, //电击模式 是否开启
				suctionMode: 1, //电击模式
				suctionIntensity: 1, //电击力度

				jitterRole: 1, // 震动权限 1有 2无 (默认给1防止闪烁，或给0等接口加载)
				shockRole: 1, // 电击权限 1有 2无

				command: "" //发送给APP的蓝牙命令
			};
		},
		mounted() {
			this.toyId = this.$route.params.toyId; //设备ID
			this.receiverID = this.$route.params.receiverID; //生成链接的ID
			this.uuid = this.$route.params.uuid; //uuid 唯一标识

			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;

			this.getRole(); //获取设备权限 1有 2无
		},
		methods: {
			queryPruchasedPackages() { //H5查询App是否已连接设备
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/pearFlowerThreeBluetooth/h5/getAppConnectToyStatus/' + this.toyId, {}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("H5查询App是否已连接设备：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							if (response.data.data.appConnectStatus == 0) { //app端连接设备的状态 默认0未连接，1已连接
								this.open4(this.$t('language000429')); //APP未连接设备
								this.isConnected = false;
							}
							if (response.data.data.appConnectStatus == 1) { //app端连接设备的状态 默认0未连接，1已连接
								this.isConnected = true;
								this.pushMsgToApp("mqtt_h5_100001") //推送
							}
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			getRole() { //获取设备权限 1有 2无
				axios.post(this.$p_url + '/feign/pearFlowerThreeBluetooth/h5/getRole/' + this.toyId, {}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("获取设备权限：", response.data)
						const state = response.data.state; // 获取状态
						if (response.data.state === "success") {
							const roles = response.data.data;
							this.jitterRole = roles.jitterRole; // 震动权限
							this.shockRole = roles.shockRole; // 电击权限
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			// 开始持续发送指令
			startContinuousAction(type) {
				this.queryPruchasedPackages() //查询是否连接
				if (!this.isConnected) {
					this.open4(this.$t('language000429'));
					return;
				}

				this.pressingType = type; // 开启 UI 动画效果
				this.executeCommand(type); // 先执行一次

				// 开启定时器，每 300 毫秒发送一次指令（频率不宜过快，防止 MQTT 阻塞）
				if (!this.continuousTimer) {
					this.continuousTimer = setInterval(() => {
						if (this.isConnected && this.cachedCommands && this.cachedCommands.length > 0) {
							this.command = this.cachedCommands; // 将缓存赋值给发送变量
							this.pushMsgToApp("mqtt_h5_100002"); // 推送给 App
							console.log("持续发送指令：" + this.command);
						}
					}, 300);
				}
			},

			// 停止发送指令
			stopContinuousAction() {
				this.queryPruchasedPackages() //查询是否连接
				this.pressingType = null; // 关闭 UI 动画效果
				if (this.continuousTimer) {
					clearInterval(this.continuousTimer);
					this.continuousTimer = null;
					this.cachedCommands = ""; // 清空缓存，下次按压重新获取最新指令
				}

				// 发送停止命令（根据二代肛塞逻辑，通常需要发送取消震动和取消电击）
				//this.generatePulseBirdStopAllShakeTail_h5();
				//this.generatePulseBirdStopAllHeadShakeHead_h5();

				console.log("已松开，停止发送");
			},

			// 具体的指令执行逻辑
			executeCommand(type) {
				console.log("获取指令");
				this.cachedCommands = "00000"

				const url = type === 'unlock' ?
					'/feign/pearFlowerThreeBluetooth/h5/getFlowerThreeToyUnlock' : //开锁
					'/feign/pearFlowerThreeBluetooth/h5/getPearFlowerThreeToyLock'; //关锁

				const params = type === 'unlock' ? {
					toyId: this.toyId,
					userId: this.receiverID,
					vibrationIntensity: 5,
					vibrationModel: 1
				} : {
					toyId: this.toyId,
					userId: this.receiverID,
					electricIntensity: 5,
					electricModel: 1
				};

				axios.post(this.$p_url + url, params, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						if (response.data.state === "success") {
							this.cachedCommands = response.data.data;
						}
					})
					.catch(error => {
						console.error('获取指令失败:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//震动模式
			toggleVibration(newValue) {
				this.queryPruchasedPackages() //查询是否连接
				if (this.jitterRole === 2) {
					this.open4("暂无权限"); // 提示无权限
					this.vibrationEnabled = false;
					return;
				}
				this.queryPruchasedPackages()
				this.vibrationEnabled = newValue
				if (newValue) { //震动是否开启
					this.generatePulseBirdLongSwayModelTail_h5() //开始震动
				} else {
					this.generatePulseBirdStopAllShakeTail_h5() //停止震动
				}
			},
			selectVibrationMode(mode) { //震动模式的选择
				this.queryPruchasedPackages()
				this.vibrationMode = mode;
				if (this.vibrationEnabled) {
					this.generatePulseBirdLongSwayModelTail_h5() //开始震动
				}
			},
			generatePulseBirdLongSwayModelTail_h5() { //开始震动
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/pearFlowerThreeBluetooth/h5/getPearFlowerThreeToyVibration', {
						toyId: this.toyId,
						userId: this.receiverID,
						vibrationIntensity: this.vibrationIntensity, //震动强度
						vibrationModel: this.vibrationMode //震动模式
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("开始震动：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_h5_100002") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//电击模式
			setSuckingStrength(newValue) {
				this.queryPruchasedPackages() //查询是否连接
				if (this.shockRole === 2) {
					this.open4("暂无权限"); // 提示无权限
					this.suctionEnabled = false;
					return;
				}
				this.queryPruchasedPackages()
				this.suctionEnabled = newValue
				if (newValue) { //电击模式是否开启
					this.PulseBirdLongSwayModelHead_h5() //开始电击
				} else {
					this.generatePulseBirdStopAllHeadShakeHead_h5() //停止电击
				}
			},
			selectSuctionMode(mode) { //电击模式的选择
				this.queryPruchasedPackages()
				this.suctionMode = mode;
				if (this.suctionEnabled) {
					this.PulseBirdLongSwayModelHead_h5() //开始电击
				}
			},
			PulseBirdLongSwayModelHead_h5() { //电击开启
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/pearFlowerThreeBluetooth/h5/getPearFlowerThreeToyElectric', {
						toyId: this.toyId,
						userId: this.receiverID,
						electricIntensity: this.suctionIntensity, //电击强度
						electricModel: this.suctionMode //电击模式
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("长摇的头部开启：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_h5_100002") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},

			//----------------------------------------------------------------------------------------------------------------------------------------------
			//震动停止 电击停止 发送mqtt给APP
			generatePulseBirdStopAllShakeTail_h5() { //震动停止
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/pearFlowerThreeBluetooth/h5/getPearFlowerThreeToyCancelVibration', {
						toyId: this.toyId,
						userId: this.receiverID
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("震动停止：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_h5_100002") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			generatePulseBirdStopAllHeadShakeHead_h5() { //电击停止
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/pearFlowerThreeBluetooth/h5/getPearFlowerThreeToyCancelElectric', {
						toyId: this.toyId,
						userId: this.receiverID
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("电击停止：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_h5_100002") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			pushMsgToApp(mqttType) { //推送给APP
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/pearFlowerThreeBluetooth/h5/pushMsgToApp', {
						toyUid: this.toyId,
						receiverID: this.receiverID,
						command: this.command,
						mqttType: mqttType
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("推送给APP：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态

						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			open2(string) {
				this.$message({
					message: string,
					type: 'success'
				});
			},
			open4(string) {
				this.$message.error(string);
			},
			//...
		},
	};
</script>

<style scoped>
	input[type="range"] {
		-webkit-appearance: none;
		appearance: none;
		background: transparent;
		cursor: pointer;
	}

	input[type="range"]::-webkit-slider-runnable-track {
		background: #ddd;
		height: 8px;
		border-radius: 4px;
	}

	input[type="range"]::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		margin-top: -4px;
		background-color: #3b82f6;
		height: 16px;
		width: 16px;
		border-radius: 50%;
	}

	input[type="range"]:focus {
		outline: none;
	}

	input[type="range"]::-moz-range-track {
		background: #ddd;
		height: 8px;
		border-radius: 4px;
	}

	input[type="range"]::-moz-range-thumb {
		border: none;
		border-radius: 50%;
		background-color: #3b82f6;
		height: 16px;
		width: 16px;
	}
</style>